<template>
	<div class="user-notice-swiper">
		<img src="@/assets/img-pc/v31.0808a585.svg" class="icon" />

		<!-- vue-awesome-swiper -->
		<swiper class="user-swiper" :options="swiperOption">
			<swiper-slide v-for="(item, index) in list" :key="index" class="swiper-item">
				<p>
					{{$t('用户')}} <span class="win">{{ item }}</span> {{$t('创建了AI策略交易')}}
				</p>
			</swiper-slide>
		</swiper>
	</div>
</template>

<script>
export default {
	name: "UserNoticeSwiper",
	props: {
		list: {
			type: Array,
			required: true,
			default: () => [],
		},
		delay: {
			type: Number,
			default: 2000, // 每条停留时长
		},
		speed: {
			type: Number,
			default: 800, // 动画速度
		},
	},
	data() {
		return {
			swiperOption: {
				direction: "vertical",
				loop: true,
				autoplay: {
					delay: this.delay,
					disableOnInteraction: true,
				},
				speed: this.speed,
			},
		};
	},
};
</script>

<style scoped lang="scss">
.user-notice-swiper {
	display: flex;
	align-items: center;
	height: 35px;
	overflow: hidden;

	.icon {
		width: 14px;
		height: 14px;
		margin-right: 8px;
	}

	.user-swiper {
		flex: 1;
		height: 35px;
	}

	.swiper-item {
		display: flex;
		align-items: center;
		height: 35px;

		p {
			font-size: 14px;
			color: #fff;
			margin: 0;

			.win {
				color: #00f0ff;
				font-weight: bold;
			}
		}
	}
}
</style>
